export const ServiceProvider = {
    RsnFinance: 'Raison Services OÜ',
    RaisonDigitalLTD: 'Raison Digital Ltd.',
    RaisonMarketUAB: 'UAB Raison Markets',
    RaisonSecuritiesLTD: 'Raison Securities Limited',
    RaisonGTPP: 'Element Global Technologies Private Portfolio Ltd.',
    ImperialFinanceAllianceCorp: 'Imperial Finance Alliance Corp.',
};
